/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycPersonFormDto } from '../../models/kyc-person-form-dto';

export interface GetIndividualForm$Params {
  processId: string;
}

export function getIndividualForm(http: HttpClient, rootUrl: string, params: GetIndividualForm$Params, context?: HttpContext): Observable<StrictHttpResponse<KycPersonFormDto>> {
  const rb = new RequestBuilder(rootUrl, getIndividualForm.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycPersonFormDto>;
    })
  );
}

getIndividualForm.PATH = '/kyc/processes/{processId}/individual-form';
